import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import { getToken } from '../../lib';
import ActivityLogsTable from '../../components/ActivityLogsTable/Table';

class ActivityLogs extends Component {
  componentDidMount() {
    const token = getToken();
    this.props.fetchActivityLogs(token);
  }

  render() {
    return (
      <div>
        <Paper className="pa3" style={{textAlign:"center"}}>
          <ActivityLogsTable
            {...this.props}
          />
        </Paper>
      </div>
    );
  }
}

export default ActivityLogs;



// WEBPACK FOOTER //
// src/routes/ActivityLogs/ActivityLogs.js